export const myMixins = {
    data() {
        return {
        }
    },
    methods: {
        refresh() {
            if (this.initList) {
                this.initList()
            } else {
                if (this.getList) {
                    this.getList(this.pager || this.pagerConfig || {
                        pageIndex: 1,
                        pageSize: 20
                    })
                }
            }
        }
    }
}
